import { render } from "./HeaderIndex.vue?vue&type=template&id=79a05a07&scoped=true"
const script = {}

import "./HeaderIndex.vue?vue&type=style&index=0&id=79a05a07&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a05a07"]])

export default __exports__